<template lang="pug">
.content.question-add-content
  .row.question-add-body
    .col-md-12.col-md-header
      .header Thêm mới câu hỏi
    .col-md-12(v-if="error")
      .form-group(style="margin: 0;")
        .alert.alert-danger(style="margin: 0;") {{error}}
    .col-md-6.categ-question
      .form-group
        label.control-label Danh mục câu hỏi*
        select#categ-id.form-control(@change="onChangeSelect($event, 'category')" required)
          option(v-for='o in categQuestion' :value='o.id' :selected="categoryID !== null && categoryID === o.id") {{o.name}}
    .col-md-6.lv-question
      .form-group
        label.control-label Cấp độ câu hỏi*
        select#level.form-control(@change="onChangeSelect($event, 'level')" required)
          option(v-for='o in lstLevel' :value='o.key' :selected="o.key === level") {{o.name}}
    .col-md-6.categ-question
      .form-group
        label.control-label Chọn môn học*
        select#subject-id.form-control(@change="onChangeSelect($event, 'subject')" required)
          option(v-for='o in subjects' :value='o.id' :selected="subjectID !== null && subjectID === o.id") {{o.name}}
    .col-md-6.lv-question.col-grade-id
      .form-group
        label.control-label Chọn khối lớp*
        //- select#grade-id.form-control(@change="onChangeSelect($event, 'grade')" required)
          option(v-for='o in grades' :value='o.id') {{o.name}}
        Select2#grade_id(v-model="gradeID" :options="grades" :settings="settingGrades")
    .clearfix
    .col-md-6.categ-question
      .form-group
        label.control-label Thời gian thực hiện (giây)*
        input#time.form-control(type='number', placeholder="Nhập" required, value='' min='0' v-model="time")
    .col-md-6.lv-question
      .form-group
        label.control-label Số hũ mật ong học sinh cần để xem đáp án *
        input#honeyjars.form-control(type='number', placeholder="Nhập" required, value='', min='0' v-model="amountHoney")
    .col-md-6.categ-question
      .form-group
        label.control-label Loại câu hỏi*
        select#type-id.form-control(@change="onChangeSelect($event, 'type-question')" required)
          option(v-for='o in lstTypeQuestion' :value='o.key' :selected="typeQuestion === o.key") {{o.name}}
    .col-md-12.content-large
      .form-group
        label.control-label.text-md-right(for="content") Nội dung câu hỏi lớn *
        froala(:tag="'textarea'" :config="config" v-model="content" @input="changeContent($event)")
      .clearfix
    .col-md-12.file-attach
      p.attach
        strong File đính kèm
      .box-attach
        .box-selected-file
          input(type='file', name='files[]' @change="onFileChange" accept=".mp3")
          span Chọn audio
          label.files Cho phép file MP3
        .box-item-attach(v-if="item" v-for="(item, index) in lstFiles")
          label 
            img.fa-paperclip(src='../../assets/images/theory/ic_baitapcuatoi@2x.png')
            span {{item.name}}
            span.material-icons.remove(@click='deleteFile(index)' style='cursor: pointer;') delete
          audio(id="player" controls)
            source(:src="item.src" type="audio/mp3")
      .clearfix

    .col-md-12.col-md-question(v-for="(qd, qd_index) in questionDetails")
      questionDetail(
        :qd_index="qd_index + 1"
        :objQd="qd"
        :type_question="typeQuestion"
        @onItemDelete="deleteQuestionDetail"
        @dataQuestionDetail="onDataQuestionDetail"
        @onEditTheory="editTheory"
        :key="force"
        :not_delete="notDelete"
      )
      .clearfix

    .col-md-12(v-if="typeQuestion === 2")
      span.add-question(@click="addQuestion") + Thêm câu hỏi mới
    .col-md-12.col-checkbox
      .item-checkbox
        input(type="checkbox" 
          name="cb_question" 
          id="cb_question"  
          @click="clickSaveEdit")
        label(for="cb_question")
        span Lưu lại và chỉnh sửa sau
      .button-handle
        button(class="btn btn-active" @click="validateSave(2)") Thêm và tạo câu hỏi mới
        button(class="btn btn-active" @click="validateSave(1)") Lưu lại và hoàn tất
        button(type="reset" class="btn btn-rest" @click="validateSave(3)") Huỷ câu hỏi

</template>

<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import questionDetail from './QuestionDetail'
import Select2 from 'v-select2-component'
import jQuery from 'jquery'
import MdNotification from '@/core/components/mdNotification'
import moment from 'moment'
import S3FileUpload from '../S3FileUpload/S3FileUpload.js'
export default {
  components: {questionDetail, Select2, jQuery, MdNotification, moment, S3FileUpload},
  data() {
    return {
      error: '',
      subjects: [],
      subjectID: null,
      grades: [],
      gradeID: [],
      categQuestion: [],
      categoryID: null,
      time: '',
      amountHoney: '',
      is_save_edit: false,
      limit: 10,
      offset: 0,
      filterLesson: '{is_delete: {_eq: false}, type_lesson: {_eq: 1}, created_by: {_eq: "' + this.$store.getters.user + '"}',
      lessons: [],
      filter: '{is_delete: {_eq: false}, created_by: {_eq: "' + this.$store.getters.user + '"}',
      lstLevel: [
        {key: 1, name: 'Sơ cấp'},
        {key: 2, name: 'Trung cấp'},
        {key: 3, name: 'Cao cấp'}
      ],
      level: 1,
      lstTypeQuestion: [
        {key: 1, name: 'Câu đơn'},
        {key: 2, name: 'Nhiều câu hỏi nhỏ'}
      ],
      typeQuestion: 1, // default cho câu hỏi nhỏ (1.đơn | 2.nhiều câu nhỏ)
      config: {
        fullPage: true,
        placeholderText: 'Nhập ...',
        charCounterCount: true,
        key: 'jUA1yD5B4D1C1F2D1pZGCTRSAPJWTLPLZHTQQb1JGZxE2F2G2B1B10B2A3E6D1G2==',
        iframe: true,
        immediateVueModelUpdate: true,
        charCounterMax: 14000,
        events: {}
      },
      content: '',
      lstFiles: [],
      audios: null,
      questionDetails: [],
      count: 1,
      settingGrades: {
        multiple: true,
        closeOnSelect: true,
        allowClear: true,
        placeholder: 'Chọn',
        escapeMarkup: this.buildInpuGrades,
        templateResult: this.formatFilterGrades,
        containerCssClass: 'custom-container-qgrades',
        dropdownCssClass: 'custom-dropdown-qgrades'
      },
      force: 0,
      notDelete: true,
      objQ: null,
      maxContent14000: false
    }
  },
  methods: {
    async forceUpdate() {
      await this.force++
    },
    // Hiện loading...
    show() {
      this.loader = this.$loading.show({
        color: '#ffffff',
        loader: 'spinner',
        width: 60,
        height: 60,
        backgroundColor: '#000000',
        opacity: 0.5,
        zIndex: 9999,
        canCancel: false
      })
    },
    buildInpuGrades(item) {
      let html = jQuery(
        '<style>' +
          '.select2-container--default .select2-selection--multiple .select2-selection__rendered {padding: 6px 15px;}' +
          '.select2-container--default .select2-selection--multiple {border-radius: 10px; min-height: 48px;}' +
          '.select2-container--default .select2-selection--multiple .select2-selection__clear {margin-right: 0px;}' +
        '</style>' +
        '<span class="placeholder">' + item + '</span>'
      )
      return html
    },
    formatFilterGrades(item) {
      let html = jQuery(
        '<style>' +
          '.select2-results {text-align: left;}' +
        '</style>' +
        '<div class="item-filter-info"><span>' + item.name + '</span></div>'
      )
      return html
    },
    changeContent(content) {
      let keyword = this.$mycontroller.stripHtml(content)
      if (keyword.length > 14000) {
        this.maxContent14000 = true
      } else {
        this.maxContent14000 = false
      }
    },
    // Hiện thông báo
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    buildInputSelect2() {
      var html = jQuery(
        '<style>' +
          '.select2-container .selection .select2-selection--multiple {border-radius:10px; height:48px;}' +
          '.select2-container .selection .select2-container--default.select2-selection--multiple {border-radius:10px !important;height:48px;}' +
        '</style>'
        )
      return html
    },
    // Sự kiện đổi checkbox (lưu và chỉnh sửa)
    clickSaveEdit(e) {
      // console.log('save and edit after: ', e.target.checked)
      this.is_save_edit = e.target.checked
    },
    // Sự kiện đổi các field Input
    onChangeSelect(e, type) {
      if (type === 'category') {
        this.categoryID = parseInt(e.target.value)
      } else if (type === 'level') {
        this.level = parseInt(e.target.value)
      } else if (type === 'subject') {
        this.subjectID = parseInt(e.target.value)
      // } else if (type === 'grade') {
      //   this.gradeID = parseInt(e.target.value)
      } else if (type === 'type-question') {
        var name = this.lstTypeQuestion.filter(({key}) => key === parseInt(e.target.value))[0].name
        try {
          this.$modal.show('dialog', {
            title: 'Xác nhận',
            text: 'Bạn sẽ mất hết dữ liệu hiện tại !! <br/> Bạn có chắc muốn chuyển qua loại câu hỏi <strong>' + name + '</strong> không?',
            buttons: [
              {
                title: 'Chấp nhận',
                default: true,
                handler: () => {
                  this.typeQuestion = parseInt(e.target.value)
                  this.questionDetails = []
                  this.count = 1
                  let data = {
                    id: this.count,
                    type: 1,
                    shuffle: true,
                    content: '',
                    explain: '',
                    point: 0,
                    subpoint: 0,
                    lessonRelated: [],
                    lessonRemaining: this.lessons,
                    answers: []
                  }
                  this.addQuestion(data)
                  this.forceUpdate()
                  this.$modal.hide('dialog')
                }
              },
              {
                title: 'Hủy yêu cầu',
                handler: () => {
                  if (parseInt(e.target.value) === 2) jQuery('#type-id').val(1)
                  else jQuery('#type-id').val(2)
                  this.$modal.hide('dialog')
                }
              }
            ]
          })
        } catch (e) {
          console.error(e)
        }
      }
    },
    // Load audio local
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.lstFiles = []
      for (let i = 0; i < files.length; i++) {
        let obj = {'name': files[i].name, 'file': files[i], 'src': URL.createObjectURL(files[i])}
        this.lstFiles.push(obj)
      }
    },
    // Xoa audio
    deleteFile(index) {
      // Xoa file dinh kem
      this.lstFiles.splice(index, 1)
    },
    // Upload S3 audio
    async updateQuestionUploadAudio($id) {
      let directory = 'audio/question'
      let config = S3FileUpload.computed.config(directory)
      let S3Client = new S3FileUpload.computed.S3Client(config)
      if (this.lstFiles.length > 0) {
        for (let index = 0; index < this.lstFiles.length; index++) {
          let audio = this.lstFiles[index]
          let file = audio.file
          let src = audio.src
          if (file !== '') {
            let fileName = audio.name.split('.')[0].replace(/ /g, '')
            let random = Math.random().toString().slice(2)
            let fieldName = `${random}_${fileName}`
            await S3Client.uploadFile(file, fieldName).then((data) => {
              this.audios = data.location
            })
          } else {
            this.audios = src
          }
        }
      }
      if (this.audios !== null) {
        this.$apollo.mutate({
          mutation: gql(graphql.UPDATE_QUESTION_AUDIO),
          variables: {
            id: $id,
            link_audio: this.audios
          }
          // update: (store, { data: { update_question } }) => {
          //   if (update_question.affected_rows) {
          //     this.loader.hide()
          //   }
          // }
        })
      }
    },
    // Lấy lesson và render câu hỏi nhỏ đầu tiên
    async refreshLessons() {
      await this.$apollo.query({
        query: gql(graphql.GET_LESSONS_FILTER(this.filterLesson + '}', null, null))
      }).then((res) => {
        // console.log('query lessons')
        this.lessons = res.data.lesson
      }).then(() => {
        this.addQuestion()
      }).catch((error) => {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.log(error)
      })
    },
    // clone lesson, question details
    async refreshLessons2() {
      await this.$apollo.query({
        query: gql(graphql.GET_LESSONS_FILTER(this.filterLesson + '}', null, null))
      }).then((res) => {
        // console.log('query lessons')
        this.lessons = res.data.lesson
      }).then(() => {
        if (this.objQ && this.objQ.question_details) {
          for (let i = 0; i < this.objQ.question_details.length; i++) {
            let tmp = this.objQ.question_details[i]
            let data = {
              id: tmp.id,
              type: tmp.type,
              shuffle: tmp.is_shuffle,
              content: tmp.content,
              explain: tmp.explain,
              point: tmp.point,
              subpoint: tmp.sub_point,
              default: true
            }
            // Xử lý hiển thị default lý thuyết liên quan
            if (tmp.lesson_questions.length > 0) {
              let lstLessonRelated = []
              let lstLessonRemaining = []
              let lstRelatedIDs = []
              for (let j = 0; j < tmp.lesson_questions.length; j++) {
                lstLessonRelated.push(tmp.lesson_questions[j].lesson)
                lstRelatedIDs.push(parseInt(tmp.lesson_questions[j].lesson.id))
              }
              if (lstLessonRelated.length > 0) {
                data = Object.assign(data, {lessonRelated: lstLessonRelated})
                for (let k = 0; k < this.lessons.length; k++) {
                  if (!lstRelatedIDs.includes(this.lessons[k].id)) {
                    lstLessonRemaining.push(this.lessons[k])
                  }
                }
                data = Object.assign(data, {lessonRemaining: lstLessonRemaining})
              }
            } else {
              data = Object.assign(data, {lessonRelated: []})
              data = Object.assign(data, {lessonRemaining: this.lessons})
            }
            // Xử lý hiển thị default đáp án
            if (tmp.answers.length > 0) {
              for (let i = 0; i < tmp.answers.length; i++) {
                if (tmp.answers[i].is_correct) tmp.answers[i].checked = true
                else tmp.answers[i].checked = false
                tmp.answers[i].count = tmp.answers[i].id
              }
              data = Object.assign(data, {answers: tmp.answers})
            } else {
              data = Object.assign(data, {answers: []})
            }
            // console.log(data)
            this.addQuestion(null, data)
          }
          // Xử lý tăng ID cho những câu hỏi nhỏ mới
          if (this.objQ.question_details[this.objQ.question_details.length - 1] !== undefined) {
            this.count = this.objQ.question_details[this.objQ.question_details.length - 1].id + 1
          }
        }
      })
    },
    // Thêm câu hỏi nhỏ
    addQuestion(e, data) {
      // console.log('addQuestion')
      this.notDelete = true
      if (data !== undefined) {
        if (data.default) this.notDelete = false
        this.questionDetails.push(data)
      } else {
        var dataQD = {
          id: this.count++,
          type: 1, // loai cau hoi
          shuffle: true, // tron dap an
          content: '',
          explain: '',
          point: 0,
          subpoint: 0,
          // lessons: this.lessons,
          lessonRelated: [],
          lessonRemaining: this.lessons,
          answers: []
        }
        // THÊM CÂU HỎI KẾ TIẾP GIỐNG CÁI LIỀN KỀ
        if (this.questionDetails.length > 0) {
          this.notDelete = false
          dataQD.type = this.questionDetails[this.questionDetails.length - 1].type
          dataQD.shuffle = this.questionDetails[this.questionDetails.length - 1].shuffle
          dataQD.content = this.questionDetails[this.questionDetails.length - 1].content
          dataQD.explain = this.questionDetails[this.questionDetails.length - 1].explain
          dataQD.point = this.questionDetails[this.questionDetails.length - 1].point
          dataQD.subpoint = this.questionDetails[this.questionDetails.length - 1].subpoint
          dataQD.lessonRelated = [...this.questionDetails[this.questionDetails.length - 1].lessonRelated]
          dataQD.lessonRemaining = [...this.questionDetails[this.questionDetails.length - 1].lessonRemaining]
          dataQD.answers = [...this.questionDetails[this.questionDetails.length - 1].answers]
        }
        this.questionDetails.push(dataQD)
      }
    },
    // Xóa câu hỏi nhỏ
    deleteQuestionDetail(index) {
      this.questionDetails.splice(index, 1)
      this.notDelete = false
      this.forceUpdate()
      // TODO: KIỂM TRA XÓA CÂU HỎI BỊ ĐÁP ÁN TRÙNG CÂU CUỐI ?
      console.log(this.questionDetails)
    },
    // Re-update các câu hỏi nhỏ lên parent
    onDataQuestionDetail(payload) {
      // console.log('onDataQuestionDetail', payload)
      for (let i = 0; i < this.questionDetails.length; i++) {
        if (payload.id === this.questionDetails[i].id) {
          this.questionDetails[i].type = payload.type
          this.questionDetails[i].shuffle = payload.shuffle
          this.questionDetails[i].content = payload.content
          this.questionDetails[i].explain = payload.explain
          this.questionDetails[i].point = payload.point
          this.questionDetails[i].subpoint = payload.subpoint
          this.questionDetails[i].lessonRelated = payload.lessonRelated
          this.questionDetails[i].lessonRemaining = payload.lessonRemaining
          // this.questionDetails[i].lessons = payload.lessons
          this.questionDetails[i].answers = payload.answers
        }
      }
      // console.log('Re-render cau hoi lon: ', this.questionDetails)
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    // mở tab mới chỉnh sửa lý thuyết liên quan
    editTheory(payload) {
      // console.log(payload)
      let route = this.$router.resolve({name: 'lesson_edit', params: { lesson_id: parseInt(payload.id) }})
      window.open(route.href, '_blank')
    },
    // Kiểm tra các fields bắt buộc
    checkForm() {
      if (this.categQuestion === null || this.categQuestion.length === 0) {
        this.showNotification('Vui lòng tạo danh mục câu hỏi', 'warning', 'top', 'right', 5000)
        this.error = 'Vui lòng tạo Danh mục câu hỏi.'
        this.scrollToTop()
        return false
      } else if (this.subjects === null || this.subjects.length === 0) {
        this.showNotification('Vui lòng chọn môn học', 'warning', 'top', 'right', 5000)
        this.error = 'Vui lòng chọn Môn học.'
        return false
      } else if (this.grades === null || this.grades.length === 0) {
        this.showNotification('Vui lòng tạo khối lớp', 'warning', 'top', 'right', 5000)
        this.error = 'Vui lòng tạo Khối lớp.'
        return false
      } else if (this.gradeID === null || this.gradeID.length === 0) {
        this.showNotification('Vui lòng chọn khối lớp', 'warning', 'top', 'right', 5000)
        this.error = 'Vui lòng chọn Khối lớp.'
        return false
      } else if (this.time === '') {
        this.showNotification('Vui lòng nhập thời gian thực hiện', 'warning', 'top', 'right', 5000)
        this.error = 'Vui lòng nhập thời gian thực hiện.'
        return false
      } else if (this.time <= 0 || this.time.toString().indexOf('.') !== -1) {
        this.showNotification('Vui lòng nhập thời gian thực hiện lớn hơn 0 và là số nguyên dương', 'warning', 'top', 'right', 5000)
        this.error = 'Vui lòng nhập thời gian thực hiện lớn hơn 0 và là số nguyên dương.'
        return false
      } else if (this.amountHoney === '') {
        this.showNotification('Vui lòng nhập số hũ mật ong cần để xem đáp án', 'warning', 'top', 'right', 5000)
        this.error = 'Vui lòng nhập số hũ mật ong cần để xem đáp án.'
        return false
      } else if (this.amountHoney < 0 || this.amountHoney.toString().indexOf('.') !== -1) {
        this.showNotification('Vui lòng nhập số hũ mật ong học sinh cần để xem đáp án là số nguyên dương', 'warning', 'top', 'right', 5000)
        this.error = 'Vui lòng nhập số hũ mật ong học sinh cần để xem đáp án là số nguyên dương.'
        return false
      } else if (this.stripedHtml(this.content) === '') {
        this.showNotification('Nhập nội dung câu hỏi lớn', 'warning', 'top', 'right', 5000)
        this.error = 'Vui lòng nhập nội dung câu hỏi lớn.'
        return false
      } else if (this.maxContent14000) {
        this.showNotification('Vui lòng nhập nội dung câu hỏi lớn tối đa 14000 ký tự', 'warning', 'top', 'right', 2000)
        this.error = 'Vui lòng nhập nội dung câu hỏi lớn tối đa 14000 ký tự.'
        return false
      } else {
        if (this.questionDetails.length > 0) {
          // Đối vs câu đơn
          if (this.typeQuestion === 1) {
            for (var j = 0; j < this.questionDetails.length; j++) {
              if (this.stripedHtml(this.questionDetails[j].explain) === '') {
                this.showNotification('Vui lòng nhập giải thích đáp án', 'warning', 'top', 'right', 5000)
                this.error = 'Vui lòng nhập giải thích đáp án.'
                return false
              } else if (this.stripedHtml(this.questionDetails[j].explain).length > 14000) {
                this.showNotification('Vui lòng nhập giải thích đáp án tối đa 14000 ký tự', 'warning', 'top', 'right', 5000)
                this.error = 'Vui lòng nhập giải thích đáp án tối đa 14000 ký tự'
                return false
              } else if (this.questionDetails[j].point === '') {
                this.showNotification('Vui lòng nhập điểm cộng khi trả lời đúng', 'warning', 'top', 'right', 5000)
                this.error = 'Vui lòng nhập điểm cộng khi trả lời đúng.'
                return false
              } else if (this.questionDetails[j].point < 0 || this.questionDetails[j].point.toString().indexOf('.') !== -1) {
                this.showNotification('Vui lòng nhập điểm cộng khi trả lời đúng là số nguyên dương', 'warning', 'top', 'right', 5000)
                this.error = 'Vui lòng điểm cộng khi trả lời đúng là số nguyên dương.'
                return false
              } else if (this.questionDetails[j].subpoint === '') {
                this.showNotification('Vui lòng nhập điểm trừ khi trả lời sai', 'warning', 'top', 'right', 5000)
                this.error = 'Vui lòng nhập điểm trừ khi trả lời sai.'
                return false
              } else if (this.questionDetails[j].subpoint < 0 || this.questionDetails[j].subpoint.toString().indexOf('.') !== -1) {
                this.showNotification('Vui lòng nhập điểm trừ khi trả lời sai là số nguyên dương', 'warning', 'top', 'right', 5000)
                this.error = 'Vui lòng điểm trừ khi trả lời sai là số nguyên dương.'
                return false
              } else if (this.questionDetails[j].lessonRelated.length === 0) {
                this.showNotification('Vui lòng chọn lý thuyết có liên quan', 'warning', 'top', 'right', 5000)
                this.error = 'Vui lòng chọn lý thuyết có liên quan.'
                return false
              } else if (this.questionDetails[j].answers.length === 0) {
                // Kiem tra thieu dap an
                this.showNotification('Vui lòng thêm đáp án cho câu hỏi nhỏ', 'warning', 'top', 'right', 5000)
                this.error = 'Vui lòng thêm đáp án cho câu hỏi nhỏ.'
                return false
              } else if (this.questionDetails[j].answers.length > 0) {
                for (let i = 0; i < this.questionDetails[j].answers.length; i++) {
                  // Kiem tra noi dung dap an empty
                  let contentAns = this.questionDetails[j].answers
                  if (this.stripedHtml(contentAns[i].content) === '') {
                    this.showNotification('Vui lòng nhập nội dung đáp án', 'warning', 'top', 'right', 5000)
                    this.error = 'Vui lòng nhập nội dung đáp án.'
                    return false
                  }
                }
              }
            }
          } else {
            // Đối với nhiều câu hỏi nhỏ
            for (var h = 0; h < this.questionDetails.length; h++) {
              if (this.stripedHtml(this.questionDetails[h].content) === '') {
                this.showNotification('Vui lòng nhập nội dung câu hỏi trong câu hỏi ' + (h + 1), 'warning', 'top', 'right', 5000)
                this.error = 'Vui lòng nhập nội dung câu hỏi trong câu hỏi ' + (h + 1)
                return false
              } else if (this.stripedHtml(this.questionDetails[h].content).length > 14000) {
                this.showNotification('Vui lòng nhập nội dung câu hỏi tối đa 14000 ký tự trong câu hỏi ' + (h + 1), 'warning', 'top', 'right', 5000)
                this.error = 'Vui lòng nhập nội dung câu hỏi tối đa 14000 ký tự trong câu hỏi ' + (h + 1)
                return false
              } else if (this.stripedHtml(this.questionDetails[h].explain) === '') {
                this.showNotification('Vui lòng nhập giải thích đáp án trong câu hỏi ' + (h + 1), 'warning', 'top', 'right', 5000)
                this.error = 'Vui lòng nhập giải thích đáp án trong câu hỏi ' + (h + 1)
                return false
              } else if (this.stripedHtml(this.questionDetails[h].explain).length > 14000) {
                this.showNotification('Vui lòng nhập giải thích đáp án tối đa 14000 ký tự trong câu hỏi ' + (h + 1), 'warning', 'top', 'right', 5000)
                this.error = 'Vui lòng nhập giải thích đáp án tối đa 14000 ký tự trong câu hỏi ' + (h + 1)
                return false
              } else if (this.questionDetails[h].point === '') {
                this.showNotification('Vui lòng nhập điểm cộng khi trả lời đúng trong câu hỏi ' + (h + 1), 'warning', 'top', 'right', 5000)
                this.error = 'Vui lòng nhập điểm cộng khi trả lời đúng trong câu hỏi ' + (h + 1)
                return false
              } else if (this.questionDetails[h].point < 0 || this.questionDetails[h].point.toString().indexOf('.') !== -1) {
                this.showNotification('Vui lòng nhập điểm cộng khi trả lời đúng là số nguyên dương trong câu hỏi ' + (h + 1), 'warning', 'top', 'right', 5000)
                this.error = 'Vui lòng điểm cộng khi trả lời đúng là số nguyên dương trong câu hỏi ' + (h + 1)
                return false
              } else if (this.questionDetails[h].subpoint === '') {
                this.showNotification('Vui lòng nhập điểm trừ khi trả lời sai trong câu hỏi ' + (h + 1), 'warning', 'top', 'right', 5000)
                this.error = 'Vui lòng nhập điểm trừ khi trả lời sai trong câu hỏi ' + (h + 1)
                return false
              } else if (this.questionDetails[h].subpoint < 0 || this.questionDetails[h].subpoint.toString().indexOf('.') !== -1) {
                this.showNotification('Vui lòng nhập điểm trừ khi trả lời sai là số nguyên dương trong câu hỏi ' + (h + 1), 'warning', 'top', 'right', 5000)
                this.error = 'Vui lòng điểm trừ khi trả lời sai là số nguyên dương trong câu hỏi ' + (h + 1)
                return false
              } else if (this.questionDetails[h].lessonRelated.length === 0) {
                this.showNotification('Lý thuyết liên quan không được để trống trong câu hỏi ' + (h + 1), 'warning', 'top', 'right', 5000)
                this.error = 'Lý thuyết liên quan không được để trống trong câu hỏi ' + (h + 1)
                return false
              } else if (this.questionDetails[h].answers.length === 0) {
                // Kiem tra thieu dap an
                this.showNotification('Vui lòng thêm đáp án cho câu hỏi nhỏ trong câu hỏi ' + (h + 1), 'warning', 'top', 'right', 5000)
                this.error = 'Vui lòng thêm đáp án cho câu hỏi nhỏ trong câu hỏi ' + (h + 1)
                return false
              } else if (this.questionDetails[h].answers.length > 0) {
                for (let i = 0; i < this.questionDetails[h].answers.length; i++) {
                  // Kiem tra noi dung dap an empty
                  let contentAns = this.questionDetails[h].answers
                  if (this.stripedHtml(contentAns[i].content) === '') {
                    this.showNotification('Vui lòng nhập nội dung đáp án trong câu hỏi ' + (h + 1), 'warning', 'top', 'right', 5000)
                    this.error = 'Vui lòng nhập nội dung đáp án trong câu hỏi ' + (h + 1)
                    return false
                  }
                }
              }
            }
          }
        } else {
          this.showNotification('Bạn phải nhập câu hỏi nhỏ', 'warning', 'top', 'right', 5000)
          this.error = 'Bạn phải nhập câu hỏi nhỏ.'
          return false
        }
        this.error = ''
        return true
      }
    },
    // Lấy plain text từ froala
    stripedHtml(htmlString) {
      var cont = document.createElement('div')
      cont.innerHTML = htmlString
      return cont.innerText
    },
    // Tạo mới câu hỏi db
    validateSave(type) {
      if (type !== 3) {
        if (!this.checkForm()) {
          return
        }
        if (type === 1) {
          // Lưu câu hỏi
          this.show()
          // console.log('lưu câu hỏi')
          let variables = {
            question: [{
              categ_id: this.categoryID !== null ? parseInt(this.categoryID) : parseInt(this.categQuestion[0].id),
              subject_id: this.subjectID !== null ? parseInt(this.subjectID) : parseInt(this.subjects[0].id),
              level: this.level,
              content: this.content,
              content_plain_text: this.stripedHtml(this.content),
              time: this.time,
              amount_honey: this.amountHoney,
              created_by: this.$store.getters.user,
              updated_by: this.$store.getters.user,
              is_type_question: this.typeQuestion,
              status: this.is_save_edit ? 0 : 1,
              status_approve: this.is_save_edit ? 1 : 3,
              is_complete: !this.is_save_edit
            }]
          }
          this.$apollo.mutate({
            mutation: gql(graphql.CREATE_QUESTION),
            variables: variables,
            update: (store, { data: { insert_question } }) => {
              if (insert_question.affected_rows) {
                let returning = insert_question.returning[0]
                // console.log('new question: ', returning.id)
                this.updateQuestionUploadAudio(returning.id)
                this.createQuestionGrade(returning.id)
                this.createQuestionDetails(returning.id, true)
              }
            }
          }).catch((error) => {
            this.loader.hide()
            this.showNotification(error, 'warning', 'top', 'right', 2000)
            console.error(error)
          })
        } else if (type === 2) {
          // Lưu và tạo mới câu hỏi
          this.show()
          // console.log('lưu và tạo mới câu hỏi')
          let variables = {
            question: [{
              categ_id: this.categoryID !== null ? parseInt(this.categoryID) : parseInt(this.categQuestion[0].id),
              subject_id: this.subjectID !== null ? parseInt(this.subjectID) : parseInt(this.subjects[0].id),
              content: this.content,
              content_plain_text: this.stripedHtml(this.content),
              time: this.time,
              amount_honey: this.amountHoney,
              created_by: this.$store.getters.user,
              updated_by: this.$store.getters.user,
              is_type_question: this.typeQuestion,
              status: this.is_save_edit ? 0 : 1,
              status_approve: this.is_save_edit ? 1 : 3,
              is_complete: !this.is_save_edit
            }]
          }
          this.$apollo.mutate({
            mutation: gql(graphql.CREATE_QUESTION),
            variables: variables,
            update: (store, { data: { insert_question } }) => {
              if (insert_question.affected_rows) {
                let returning = insert_question.returning[0]
                // console.log('new question: ', returning.id)
                this.updateQuestionUploadAudio(returning.id)
                this.createQuestionGrade(returning.id)
                this.createQuestionDetails(returning.id, false)
              }
            }
          }).catch((error) => {
            this.loader.hide()
            this.showNotification(error, 'warning', 'top', 'right', 2000)
            console.error(error)
          })
        }
      } else {
        this.$router.push('/question')
      }
    },
    // Tạo mới câu nhỏ db
    async createQuestionDetails(questionID, format) {
      // console.log('create question details')
      for (let k = 0; k < this.questionDetails.length; k++) {
        let qd = this.questionDetails
        var variables = {
          question_details: [{
            question_id: questionID,
            content: qd[k].content,
            content_plain_text: this.stripedHtml(qd[k].content),
            explain: qd[k].explain,
            type: qd[k].type,
            is_shuffle: qd[k].shuffle,
            point: parseInt(qd[k].point),
            sub_point: parseInt(qd[k].subpoint),
            created_by: this.$store.getters.user,
            updated_by: this.$store.getters.user
          }]
        }
        // console.log(variables)
        await this.$apollo.mutate({
          mutation: gql(graphql.CREATE_QUESTION_DETAILS),
          variables: variables,
          update: (store, { data: { insert_question_details } }) => {
            if (insert_question_details.affected_rows) {
              let returning = insert_question_details.returning[0]
              // this.createAnswers(returning.id, qd[k].answers)
              if (qd[k].lessonRelated.length > 0) {
                var lstLessons = qd[k].lessonRelated
                for (let g = 0; g < lstLessons.length; g++) {
                  let variables = {
                    object: [{
                      question_id: returning.id,
                      lesson_id: parseInt(lstLessons[g].id),
                      created_by: this.$store.getters.user,
                      updated_by: this.$store.getters.user
                    }]
                  }
                  this.$apollo.mutate({
                    mutation: gql(graphql.CREATE_LESSON_QUESTION),
                    variables: variables
                  }).catch((error) => {
                    this.loader.hide()
                    console.error(error)
                  })
                }
              }
              if (qd[k].answers.length > 0) {
                var lstAnswers = qd[k].answers
                for (let v = 0; v < lstAnswers.length; v++) {
                  let variables = {
                    answers: [{
                      question_details_id: returning.id,
                      value: lstAnswers[v].value,
                      content: lstAnswers[v].content,
                      content_plain_text: this.stripedHtml(lstAnswers[v].content),
                      is_correct: lstAnswers[v].checked,
                      created_by: this.$store.getters.user,
                      updated_by: this.$store.getters.user
                    }]
                  }
                  this.$apollo.mutate({
                    mutation: gql(graphql.CREATE_ANSWER),
                    variables: variables
                  }).catch((error) => {
                    this.loader.hide()
                    console.error(error)
                  })
                }
              }
            }
          }
        }).catch((error) => {
          this.loader.hide()
          console.error(error)
        })
      }
      // console.log('FINISH QUESTION')
      if (format) {
        this.loader.hide()
        this.showNotification('Tạo câu hỏi thành công', 'success', 'top', 'right', 2000)
        this.$router.push('/question')
      } else {
        // this.$router.go(0)
        // clone câu hỏi hiện tại
        this.loader.hide()
        this.questionDetails = []
        this.categoryID = null
        this.subjectID = null
        this.gradeID = []
        this.content = ''
        this.time = ''
        this.amountHoney = ''
        this.lstFiles = []
        this.is_save_edit = false
        this.forceUpdate()
        this.onCreated(questionID)
      }
    },
    // Tạo mới đáp án db
    async createAnswers(qdID, lstAnswers) {
      // console.log('create answers')
      if (lstAnswers.length > 0) {
        // console.log(lstAnswers, typeof lstAnswers)
        for (let v = 0; v < lstAnswers.length; v++) {
          var variables = {
            answers: [{
              question_details_id: qdID,
              value: lstAnswers[v].value,
              content: lstAnswers[v].content,
              content_plain_text: this.stripedHtml(lstAnswers[v].content),
              is_correct: lstAnswers[v].checked,
              created_by: this.$store.getters.user,
              updated_by: this.$store.getters.user
            }]
          }
          await this.$apollo.mutate({
            mutation: gql(graphql.CREATE_ANSWER),
            variables: variables,
            update: (store, { data: { insert_answer } }) => {
              if (insert_answer.affected_rows) {
                let returning = insert_answer.returning[0]
                console.log(returning.id)
              }
            }
          }).catch((error) => {
            this.loader.hide()
            console.error(error)
          })
        }
      }
    },
    // Tạo mới khối lớp liên quan db
    async createQuestionGrade(questionID) {
      if (this.gradeID !== null && this.gradeID.length > 0) {
        for (let f = 0; f < this.gradeID.length; f++) {
          let variables = {
            object: [{
              question_id: questionID,
              grade_id: parseInt(this.gradeID[f]),
              created_by: this.$store.getters.user,
              updated_by: this.$store.getters.user
            }]
          }
          await this.$apollo.mutate({
            mutation: gql(graphql.CREATE_QUESTION_GRADE),
            variables: variables
          }).catch((error) => {
            this.loader.hide()
            console.error(error)
          })
        }
      }
    },
    // Hàm Clone câu hỏi
    async onCreated(questionID) {
      await this.$apollo.query({
        query: gql(graphql.GET_FIRST_QUESTION),
        variables: {
          where: {
            id: {'_eq': questionID}
          }
        },
        fetchPolicy: 'no-cache',
        error(error) {
          if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
            this.$router.go(0)
          }
          console.log(error.message)
        }
      }).then(async (result) => {
        // console.log(result.data.question)
        if (result && result.data && result.data.question.length > 0) {
          let item = result.data.question[0]
          this.objQ = item
          this.categoryID = item.categ_id
          this.subjectID = item.subject_id
          this.content = item.content !== null && item.content
          this.level = item.level
          this.time = item.time
          this.amountHoney = item.amount_honey
          this.typeQuestion = item.is_type_question
          this.is_save_edit = !(item.is_complete)
          if (item.link_audio !== null) {
            let url = item.link_audio
            let split = url.split('/')
            let fileName = split[split.length - 1]
            let obj = {'name': fileName, 'file': '', 'src': url}
            this.lstFiles.push(obj)
          }
          let arrGrades = item.question_grade
          if (arrGrades !== null && arrGrades.length > 0) {
            for (let index = 0; index < arrGrades.length; index++) {
              this.gradeID.push(arrGrades[index].grade.id)
            }
          }
          await this.refreshLessons2()
        } else {
          this.showNotification('Vui lòng xem lại, không có câu hỏi này', 'danger', 'top', 'right', 5000)
        }
      })
    }
  },
  mounted() {
    if (this.$route.params.clone_question_id === undefined) {
      jQuery('#type-id').val(1) // default (1.đơn | 2.nhiều câu nhỏ)
      this.refreshLessons()
    }
  },
  async created() {
    // clone câu hỏi mới
    if (this.$route.params.clone_question_id !== undefined) {
      this.onCreated(this.$route.params.clone_question_id)
    }
  },
  apollo: {
    categQuestion: {
      query() {
        // console.log(graphql.GET_CATEGORY_QUESTION_FILTER(this.filter + this.filtername + '}', this.offset, this.limit))
        return gql(graphql.GET_CATEGORY_QUESTION_FILTER(this.filter + '}', null, null))
      },
      update: data => {
        return data.category_question
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
      }
    },
    subjects: {
      query: gql(graphql.GET_SUBJECT_USER),
      fetchPolicy: 'no-cache',
      variables() {
        let variables = {
          where: {
            is_delete: {'_eq': false},
            user_id: {'_eq': this.$store.getters.user},
            status: {'_eq': 2}
          },
          orderBy: {created_at: 'asc'}
        }
        return variables
      },
      update: data => {
        if (data.subject_user.length > 0) {
          let lstSubjects = []
          for (let i = 0; i < data.subject_user.length; i++) {
            lstSubjects.push(data.subject_user[i].subject)
          }
          return lstSubjects
        }
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error.message)
      }
    },
    grades: {
      query: gql(graphql.GET_GRADES),
      update: data => {
        for (let i = 0; i < data.grades.length; i++) {
          data.grades[i].text = data.grades[i].name
        }
        return data.grades
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.question-add-content {
  .question-add-body {
    .col-md-header {
      margin-bottom: 10px;
    }
    .header {
      font-size: 20px;
      font-weight: bold;
      text-align: left;
      color: #5F6468;
      display: inline-block;
    }
    .lv-question {
      padding-left: 7.5px;
      .form-group {
        label {color: black; font-weight: bold; font-family: 'adobe-clean' sans-serif;}
        margin-top: 0;
        input, select {background-color: white;}
      }
    }
    .categ-question {
      padding-right: 7.5px;
      .form-group {
        label {color: black; font-weight: bold; font-family: 'adobe-clean' sans-serif;}
        margin-top: 0;
        input, select {background-color: white;}
      }
    }
    // .col-grade-id {
    //   span.select2 .select2-container .select2-container--below {
    //     span.select2-selection .select2-selection--multiple {
    //       height: 48px;
    //       min-height: 48px;
    //     }
    //   }
    // }
    .content-large {
      .form-group {
        margin-top:0;
        label {color: black; font-weight: bold; font-family: 'adobe-clean' sans-serif;}
      }
    }
    .file-attach {
      margin-bottom: 20px;
      .attach {margin-top: 5px; font-size: 11px; font-weight: bold; margin-bottom: 0; color: black;}
        .box-attach{background: #fff; padding: 20px 10px 5px; border-radius: 10px; box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);}
          .box-item-attach{padding: 5px 10px !important; }
          // .box-item-attach:last-child{border-bottom: 1px solid #EAEAEA !important;}
          .box-item-attach label{width: 100%; display:block; color:#000;}
          .box-item-attach .fa-paperclip{width:11px; height: 15px;}
          .box-item-attach span{padding-left: 10px;}
          .box-item-attach .remove{float:right; display:block; z-index: 100;}
          .box-selected-file {
            padding: 0 10px; margin-bottom:10px; position: relative; width: fit-content;
            input[type=file] {
                opacity: 0;
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 100;
            }
          }
          .box-selected-file span{padding: 5px 15px; background: #FFFFFF 0% 0% no-repeat padding-box;border: 0.5px solid #B4B4B4; border-radius: 3px; cursor: pointer;margin-right: 15px;}
          .box-selected-file label.files{color: #969FAD;}
    }

    .add-question {
      font-family: 'adobe-clean' sans-serif;
      text-decoration: underline;
      color: blue;
      cursor: pointer;
      font-size: 15px;
    }
    .col-checkbox {
      margin-top: 10px;
      // input[type=checkbox] {margin-right: 10px;}
      .button-handle {
        .btn{text-align: left; font-size: 15px;letter-spacing: 0px;color: #333333; padding: 12px 30px; text-transform: inherit;}
        .btn-active{background: #FFD311 0% 0% no-repeat padding-box; border-radius: 5px;border: 0 none;}
        .btn-active:nth-child(2) {margin: 0 20px;}
        .btn-rest{border: 0 none; background: transparent; box-shadow: none;}
        .btn-active:hover,.btn-active:active, .btn-active:focus{background: #FFD311 0% 0% no-repeat padding-box; color:#333;box-shadow: none;}
        .btn-rest:hover, .btn-rest:active, .btn-rest:focus{background: transparent;color: #333;box-shadow: none;}
      }
      .item-checkbox{
        display:inline-flex; 
        justify-content: center;
        align-items: center; 
        padding: 7px 0;
        span {margin-left: 8px; font-size: 15px;}
        input{display:none;}
        input + label{cursor: pointer;background: url("../../assets/images/faces/ic_check_box_outline@2x.png") no-repeat center center;height: 24px;width: 24px;display:inline-block; background-size: cover; margin: 0;}
        input:checked + label{cursor: pointer;background: url("../../assets/images/faces/ic_check_box@2x.png") no-repeat center center;height: 24px;width: 24px;display:inline-block;background-size: cover;}
      }
    }
  }
}
@media (max-width: 414px) {
  .question-add-content {
    .question-add-body {
      .lv-question {padding-left: 15px;
        &.col-xs-6 {padding-left: 4px;}
        &.col-xs-5 {padding-left: 0px;}
      }
      .categ-question {padding-right: 15px;
        &.col-xs-6 {padding-right: 4px;}
        &.col-xs-7 {padding-right: 8px;}
      }
      .file-attach {
        .box-attach {
          .box-item-attach {
            audio {width: 100%; margin-top: 6px;}
          }
        }
      }
      .col-checkbox {
        .button-handle {
          .btn-active:nth-child(2) {margin: 0;}
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// add.vue?7f275c2e